module.exports = __webpack_public_path__ + "img/PENDING.173e8dea.svg";